import { render, staticRenderFns } from "./Page-2.vue?vue&type=template&id=7444cb6e&scoped=true&"
var script = {}
import style0 from "./Page-2.vue?vue&type=style&index=0&id=7444cb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444cb6e",
  null
  
)

export default component.exports